import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./EmailSectionModel.css";
import EmailSectionRegistry, { getAllSections, getSectionsByType } from "../../services/EmailSectionRegistry";

const EmailSectionModal = ({ isOpen, onClose, onAddSection }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSection, setSelectedSection] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");
  
  if (!isOpen) return null;

  const handleAdd = () => {
    if (selectedSection) {
      onAddSection(selectedSection);
      handleClose();
    }
  };
  
  const handleClose = () => {
    setSelectedSection(null);
    setSearchTerm("");
    setActiveFilter("all");
    onClose();
  };
  
  const filterSections = () => {
    let sections = getAllSections();
    
    // Filter by type if not "all"
    if (activeFilter !== "all") {
      sections = getSectionsByType(activeFilter);
    }
    
    // Filter by search term
    if (searchTerm) {
      sections = sections.filter(section => 
        section.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        section.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    return sections;
  };
  
  const filteredSections = filterSections();
  
  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && handleClose()}
    >
      <div className="section-modal">
        <div className="modal-header">
          <h3 className="modal-title">Add new section</h3>
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>
        </div>

        <div className="search-filter-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search sections"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="filter-tabs">
            <button 
              className={`filter-tab ${activeFilter === 'all' ? 'active' : ''}`} 
              onClick={() => setActiveFilter('all')}
            >
              All
            </button>
            <button 
              className={`filter-tab ${activeFilter === 'header' ? 'active' : ''}`} 
              onClick={() => setActiveFilter('header')}
            >
              Headers
            </button>
            <button 
              className={`filter-tab ${activeFilter === 'content' ? 'active' : ''}`} 
              onClick={() => setActiveFilter('content')}
            >
              Content
            </button>
            <button 
              className={`filter-tab ${activeFilter === 'interactive' ? 'active' : ''}`} 
              onClick={() => setActiveFilter('interactive')}
            >
              Interactive
            </button>
            <button 
              className={`filter-tab ${activeFilter === 'footer' ? 'active' : ''}`} 
              onClick={() => setActiveFilter('footer')}
            >
              Footers
            </button>
          </div>
        </div>

        <div className="sections-grid">
          {filteredSections.map((section) => (
            <div
              key={section.id}
              className={`section-preview ${
                selectedSection?.id === section.id ? "selected border border-danger" : ""
              }`}
              onClick={() => setSelectedSection(section)} 
            >
              <img src={section.image} alt={section.title} />
              <div>
              <h4>{section.title}</h4>
              <p className="section-description">{section.description}</p>
              </div>
            </div>
          ))}
          
          {filteredSections.length === 0 && (
            <div className="no-results">
              <p>No sections match your search criteria</p>
            </div>
          )}
        </div>

        <button
          className="add-button"
          disabled={!selectedSection}
          onClick={handleAdd}
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default EmailSectionModal;
